import { ElementStatus } from '../../../rule-element/types';
export const IMAGE_EXTENSION_REGEX = /\.(jpg|jpeg|gif|png|bmp|svg|heic|avif|apng|webp)/i;
export const hasImageExtension = text => IMAGE_EXTENSION_REGEX.test(text);
export const imageNeedsAltText = img => (!img.altText || hasImageExtension(img.altText)) && !(img.isDecorative && !img.isLinked);
const DEFAULT_FAILED_TO_GENERATE_WARNING = 'Unable to generate alt text for this image. Try again or add the text manually.';
export const getFormStatusAndStatusMessage = (status, options) => {
  const opts = typeof options === 'string' ? {
    failedToGenerateWarning: options
  } : options;
  if (opts != null && opts.value && opts.imageExtensionErrorMessage && hasImageExtension(opts.value)) {
    return {
      message: opts.imageExtensionErrorMessage,
      status: 'error'
    };
  }
  switch (status) {
    case ElementStatus.Warning:
      return {
        message: (opts == null ? void 0 : opts.failedToGenerateWarning) ?? DEFAULT_FAILED_TO_GENERATE_WARNING,
        status: 'warning'
      };
    default:
      return null;
  }
};
//# sourceMappingURL=get-form-status-and-status-message.js.map